import React from 'react'
import { colors } from '../constants/colors'

const NotificationModal = ({ isOpen, onClose, type = 'info', title, message, showCancel = false, onConfirm, showOverlay = true }) => {
  if (!isOpen) return null

  const getIcon = () => {
    switch (type) {
      case 'success':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )
      case 'error':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )
      case 'warning':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )
      default:
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )
    }
  }

  const getTitleColor = () => {
    switch (type) {
      case 'success': return '#10B981'
      case 'error': return '#EF4444'
      case 'warning': return '#F59E0B'
      default: return colors.text.primary
    }
  }

  const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: showOverlay ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000
  }

  const modalStyle = {
    backgroundColor: colors.background.primary,
    borderRadius: '12px',
    padding: '24px',
    width: '400px',
    maxWidth: '90vw',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    textAlign: 'center'
  }

  const iconStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '16px'
  }

  const titleStyle = {
    fontSize: '18px',
    fontWeight: '600',
    color: getTitleColor(),
    marginBottom: '8px'
  }

  const messageStyle = {
    fontSize: '14px',
    color: colors.text.secondary,
    marginBottom: '24px',
    lineHeight: '1.5'
  }

  const buttonContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    gap: '12px'
  }

  const buttonStyle = {
    padding: '10px 20px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    border: 'none',
    transition: 'all 0.2s ease'
  }

  const primaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: colors.primary,
    color: 'white'
  }

  const secondaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: colors.background.tertiary,
    color: colors.text.primary,
    border: `1px solid ${colors.borderVariants.medium}`
  }

  return (
    <div style={modalOverlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <div style={iconStyle}>
          {getIcon()}
        </div>
        
        <h3 style={titleStyle}>{title}</h3>
        <p style={messageStyle}>{message}</p>
        
        <div style={buttonContainerStyle}>
          {showCancel && (
            <button
              style={secondaryButtonStyle}
              onClick={onClose}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = colors.background.secondary
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = colors.background.tertiary
              }}
            >
              Cancel
            </button>
          )}
          <button
            style={primaryButtonStyle}
            onClick={onConfirm || onClose}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = colors.primaryDark
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = colors.primary
            }}
          >
            {showCancel ? 'Confirm' : 'OK'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotificationModal
